import React from "react";
import PropTypes from 'prop-types';
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from '@mui/icons-material/Add';
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import useMyProfileVM from "../../views/MyAccountView/MyProfileView/useMyProfileVM";

import "./AddressInfo.style.scss";

const AddressInfo = () => {
    const vm = useMyProfileVM();
    const navigate = useNavigate();

    const { address1, city, state, country, zipCode, phone1 } = vm.userData.address || {};

    const handleEditAddress = async () => {
        navigate('/myaccount/myprofile?editAddress=true');
    };


    return (
        <div className="AddressInfo">
            <div className="editAddress" onClick={handleEditAddress}>
                {address1 && city && state && country && zipCode ? (
                    <>
                        <EditIcon className="editIcon" /> <FormattedMessage id="myAccountView.withdrawFunds.editAddress" />
                    </>
                ) : (
                    <>
                        <AddIcon className="addIcon" /> <FormattedMessage id="myAccountView.withdrawFunds.addAddress" />
                    </>
                )}
            </div>
            <div className="addressContent">
                <div className="addressLine1">{address1}</div>
                {city && state && <div className="cityState">{city}, {state}</div>}
                {country && zipCode && <div className="countryZipCode">{country}, {zipCode}</div>}
                <div className="phone">{phone1}</div>
            </div>
        </div>
    );
};

AddressInfo.propTypes = {
    userData: PropTypes.shape({
        address: PropTypes.shape({
            address1: PropTypes.string,
            city: PropTypes.string,
            state: PropTypes.string,
            country: PropTypes.string,
            zipCode: PropTypes.string,
            phone1: PropTypes.string,
        })
    })
};

export default AddressInfo;